import React, { useState } from 'react';
import { Linkedin, Mail, Link2, Check, MessageCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ShareButtons = ({ slug, title, excerpt, light = false }) => {
  const [copied, setCopied] = useState(false);
  const url = `${API}/share/articles/${slug}`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${title} — Ometis Patrimoine\n${url}`)}`;
  const mail = `mailto:?subject=${encodeURIComponent(`${title} — Ometis Patrimoine`)}&body=${encodeURIComponent(`${excerpt}\n\nLire l’article : ${url}`)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const base = `inline-flex items-center gap-2 px-4 py-2.5 text-xs tracking-wider uppercase font-medium border transition-colors duration-300 ${light ? 'border-white/25 text-white/85 hover:border-[#ff7300] hover:text-[#ff7300]' : 'border-black/15 text-[#010c23] hover:border-[#ff7300] hover:text-[#ff7300]'}`;

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-buttons">
      <span className={`text-[11px] tracking-[0.3em] uppercase ${light ? 'text-white/60' : 'text-[#010c23]/50'}`}>Partager</span>
      <a href={linkedin} target="_blank" rel="noreferrer" className={base} data-testid="share-linkedin"><Linkedin size={14} /> LinkedIn</a>
      <a href={whatsapp} target="_blank" rel="noreferrer" className={base} data-testid="share-whatsapp"><MessageCircle size={14} /> WhatsApp</a>
      <a href={mail} className={base} data-testid="share-email"><Mail size={14} /> Email</a>
      <button type="button" onClick={copy} className={base} data-testid="share-copy">{copied ? <><Check size={14} /> Lien copié</> : <><Link2 size={14} /> Copier le lien</>}</button>
    </div>
  );
};

export default ShareButtons;
